import { defaultHttpClient } from '../../httpClient';
import { atomicRendererDataConverter } from './atomicRendererDataConverter';
import type { IScreensReadParams, ScreensReadResponse } from './types';

/** - 아토믹을 그리는 api */
export const getScreens = async ({
  next_token,
  screen,
  ...rest
}: IScreensReadParams) => {
  const { data } = await defaultHttpClient.request<ScreensReadResponse>(
    {
      method: 'GET',
      url: `/api/v2/screens/${screen}/`,
      params: {
        ...(next_token && {
          next_token,
        }),
        ...rest,
      },
    },
    {
      arrayFormat: 'repeat',
    },
  );
  return atomicRendererDataConverter(data);
};
